import { logAppClosed } from './analytics'
import { usePersistedUIStore } from 'store/UI'

const closeApp = () => {
  logAppClosed()
  window.epharmacy_close?.()
  window.parent.postMessage(
    {
      type: 'closing'
    },
    '*'
  )
}

export default closeApp
